import { useEffect, useState } from 'react';
import useTrackHomepageEvents from 'src/features/home/presentation/hooks/useTrackHomepageEvents';

type TrackProductsSearchHookParams = {
  debouncedSearchTerm: string | null;
  isLoading: boolean;
  isChanging: boolean;
  products: { length: number };
};

const useTrackProductsSearch = ({
  debouncedSearchTerm,
  isLoading,
  isChanging,
  products,
}: TrackProductsSearchHookParams) => {
  const [lastTrackedSearch, setLastTrackedSearch] = useState<string | null>(
    null
  );
  const { trackProductSearch } = useTrackHomepageEvents();

  useEffect(() => {
    if (
      debouncedSearchTerm &&
      !isLoading &&
      !isChanging &&
      debouncedSearchTerm !== lastTrackedSearch
    ) {
      trackProductSearch({
        search: debouncedSearchTerm,
        resultsCount: products.length,
      });

      setLastTrackedSearch(debouncedSearchTerm);
    }
  }, [
    debouncedSearchTerm,
    products.length,
    trackProductSearch,
    isLoading,
    isChanging,
    lastTrackedSearch,
  ]);
};

export default useTrackProductsSearch;
